import { Component, OnInit } from '@angular/core';
import { RxjsService } from '../services/rxjs.service';

@Component({
  selector: 'app-card-add',
  templateUrl: './card-add.component.html',
  styleUrls: ['./card-add.component.css']
})
export class CardAddComponent implements OnInit {
  message = "Card Saved Successfully";

  constructor(public rxjsSupport: RxjsService) {
  }

  ngOnInit(): void {
  }

  // closePopUp() {
  //   console.log("close pop up ");
  //   this.rxjsSupport.setNew(true);
  // }

}
